module.exports = __webpack_public_path__ + "static/media/covi_can_sta.9feed823.png";